import { mergeObject } from '../helper/helper';

export default class MobileSidebar {
	constructor(elements) {
		this.elements = elements;

		this.toggleAnimation = undefined;

		if (!this.elements.toggle || !this.elements.sidebar) {
			return;
		}

		this.initSidebar();

		window.addEventListener('resize', this.setOffset.bind(this), { passive: true });
		this.elements.toggle.addEventListener('click', this.toggleSidebar.bind(this));
	}

	toggleSidebar() {
		if (this.elements.sidebar.getAttribute('aria-expanded') === 'true') {
			this.toggleAnimation.reverse();
			this.elements.sidebar.setAttribute('aria-expanded', 'false');
			this.elements.sidebar.classList.remove('open');
		} else {
			this.toggleAnimation.play();
			this.elements.sidebar.setAttribute('aria-expanded', 'true');
			this.elements.sidebar.classList.add('open');
		}
	}

	initSidebar() {
		this.toggleAnimation = gsap.timeline({
			paused: true
		});

		gsap.set(this.elements.sidebar, { x: 0 });
		this.toggleAnimation.fromTo(this.elements.sidebar, {
			xPercent: -100,
		}, {
			xPercent: 0,
			duration: 0.3,
			ease: 'power2.out'
		});

		window.addEventListener('DOMContentLoaded', () => {
			this.setOffset();
			this.setToggleOffset();
			this.elements.sidebar.classList.add('loaded');
		});

		window.addEventListener('scroll', this.setToggleOffset.bind(this), { passive: true });
	}

	setOffset() {
		const adminbar = document.getElementById('wpadminbar');
		let offset = 0;
		if (adminbar) {
			offset += adminbar.offsetHeight;
		}

		if (document.body.classList.contains('woocommerce-demo-store') && document.getElementById('hpy-store-notice')) {
			offset += document.getElementById('hpy-store-notice').offsetHeight;
		}

		this.elements.sidebar.style.top = `${offset}px`;
		this.elements.sidebar.style.height = `calc( 100% - ${offset}px )`;
	}

	setToggleOffset() {
		let offset = 15;
		let rect = document.getElementById('masthead').getBoundingClientRect();
		offset += rect.bottom;
		this.elements.toggle.classList.add('offset');
		if (offset < 0) {
			this.elements.toggle.classList.remove('offset');
			offset = 0;
		}

		this.elements.toggle.style.top = `${offset}px`;
	}

	maybeCloseSidebar() {
		this.toggleAnimation.reverse();
		this.elements.sidebar.setAttribute('aria-exanded', 'false');
		this.elements.sidebar.classList.remove('open');
	}
}